export const SET_PANEL_LAYOUT_CONFIG = 'SET_PANEL_LAYOUT_CONFIG';
export const LOCK_PANEL_LAYOUT_CONFIG = 'LOCK_PANEL_LAYOUT_CONFIG';
export const UNLOCK_PANEL_LAYOUT_CONFIG = 'UNLOCK_PANEL_LAYOUT_CONFIG';
export const CLEAR_PANEL_LAYOUT = 'CLEAR_PANEL_LAYOUT';
export const MOUNT_RIGHT_PANEL = 'MOUNT_RIGHT_PANEL';

export const setPanelLayoutConfig = (config) => ({
  type: SET_PANEL_LAYOUT_CONFIG,
  config,
});

export const lockPanelLayoutConfig = () => ({
  type: LOCK_PANEL_LAYOUT_CONFIG,
});

export const unlockPanelLayoutConfig = () => ({
  type: UNLOCK_PANEL_LAYOUT_CONFIG,
});

export const clearPanelLayout = () => ({
  type: CLEAR_PANEL_LAYOUT,
});

export const setRightPanelMount = () => ({
  type: MOUNT_RIGHT_PANEL,
});
